<template>
  <div class="bounce-wrapper">
    <div class="ball-shadow"></div>
    <div class="ball"></div>
  </div>
</template>

<script>
export default {

  name: 'Bounce',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>

.ball {
  background: black;
  border-radius: 50%;
  height: 10vw;
  width: 10vw;
}

.ball-shadow {
  background: radial-gradient(ellipse 50% 50%, #000 0%, #fff 100%);
  margin-bottom: 13vh;
  height: 50px;
  width: 10vw;
  opacity: 0.5;
}

.bounce-wrapper {
  height: 100%;
  left: 50%;
  position: absolute;
}

.bounce-wrapper .ball-shadow {
  animation-timing-function: ease-out;
  animation-direction: alternate;
  animation-duration: 0.7s;
  animation-name: grow;
  animation-iteration-count: infinite;
  bottom: 0;
  position: absolute;
  margin-left: -5vw;
}

.bounce-wrapper .ball {
  animation-timing-function: ease-out;
  animation-direction: alternate;
  animation-duration: 0.7s;
  animation-name: bounce;
  animation-iteration-count: infinite;
  margin-left: -5vw;
  position: absolute;
}

@keyframes grow {
  from {
    bottom: 0;
    margin-left: -100px;
    height: 50px;
    width: 200px;
  }

  to {
    bottom: 20px;
    margin-left: 0;
    height: 10px;
    width: 15px;
  }
}

@keyframes bounce {
  0% {
    bottom: 13vh;
    transform: scaleY(0.75);
  }

  20% {
    transform: scaleY(1);
  }

  100% {
    bottom: 60vh;
  }
}

</style>
